module.exports = __webpack_public_path__ + "static/media/swap-left.be9b0c03.svg";